module.exports = __webpack_public_path__ + "cd455783/img/copy-icon.408fdb2d.svg";